import { useState } from "react";
import { api } from "../lib/api";
import { EnvelopeSimple, ArrowRight, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch (_) {
      // Intentionally generic — never reveal whether the email exists.
    } finally {
      setBusy(false);
      setSent(true);
    }
  };

  return (
    <AuthShell title="Reset your password">
      {sent ? (
        <div className="space-y-4" data-testid="forgot-password-sent">
          <div className="flex items-center gap-2 text-sm">
            <CheckCircle size={18} weight="fill" className="text-green-600" />
            <span>If an account exists for that email, a password reset link has been sent.</span>
          </div>
          <p className="text-xs text-[hsl(var(--muted))]">
            The link expires in 24 hours and can be used once. Check your inbox (and spam).
          </p>
          <a href="/staff/login" className="btn-primary w-full justify-center" data-testid="back-to-login">
            Back to sign in
          </a>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-3" data-testid="forgot-password-form">
          <p className="text-xs text-[hsl(var(--muted))]">
            Enter your Air12 email and we'll send you a link to set a new password.
          </p>
          <label className="block">
            <div className="overline mb-1.5">EMAIL</div>
            <input type="email" className="input-field" value={email} required autoComplete="email"
                   onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          </label>
          <button type="submit" className="btn-primary w-full justify-center mt-2" disabled={busy || !email}
                  data-testid="forgot-submit-button">
            <EnvelopeSimple size={14} weight="bold" /> Send reset link <ArrowRight size={14} weight="bold" />
          </button>
          <div className="text-center">
            <a href="/staff/login" className="text-xs underline text-[hsl(var(--muted))]" data-testid="forgot-back-link">
              Back to sign in
            </a>
          </div>
        </form>
      )}
    </AuthShell>
  );
}

export function AuthShell({ title, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))] p-4">
      <div className="w-full max-w-md grid-card grid-card-strong p-8">
        <div className="mb-6">
          <div className="heading text-2xl">Air12</div>
          <div className="overline mt-1">{title}</div>
        </div>
        {children}
      </div>
    </div>
  );
}
